import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from './Link';
import { getContextualUrl } from '../scripts/utils';
var Dropdown = function Dropdown(_ref) {
  var isLegacy = _ref.isLegacy,
    isOpen = _ref.isOpen,
    listName = _ref.listName,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    onClickHandler = _ref.onClickHandler;
  var menuItemsList = function menuItemsList(_menuItems) {
    return _menuItems.map(function () {
      var dropdownItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/React.createElement("li", {
        key: dropdownItem.text
      }, /*#__PURE__*/React.createElement(Link, {
        url: getContextualUrl(dropdownItem.properties.link, undefined, undefined, isLegacy),
        text: dropdownItem.text,
        target: dropdownItem.properties.target
      }));
    });
  };
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isOpen,
    "aria-haspopup": "true",
    className: "site-footer__feature-toggle",
    title: listName && listName.toUpperCase() || '',
    "data-listname": listName,
    onClick: onClickHandler
  }, listName && listName.toUpperCase()), /*#__PURE__*/React.createElement("ul", {
    className: classNames('site-footer__feature-dropdown', {
      'show-list': isOpen
    })
  }, menuItems.length > 0 ? menuItemsList(menuItems) : /*#__PURE__*/React.createElement("li", null)));
};
Dropdown.propTypes = {
  isLegacy: PropTypes.bool,
  isOpen: PropTypes.bool,
  listName: PropTypes.string.isRequired,
  menuItems: PropTypes.instanceOf(Array).isRequired,
  onClickHandler: PropTypes.func.isRequired
};
export default Dropdown;